import React from 'react';
import { Card, Button, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';

const { Text } = Typography;

const Login: React.FC = () => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

  const handleGoogleLogin = () => {
    const authUrl = new URL('/api/auth/google', API_URL);
    authUrl.searchParams.set('returnOrigin', window.location.origin);
    window.location.assign(authUrl.toString());
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#121212',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: '400px',
          background: '#1a1a1a',
          border: '1px solid #333333',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img
            src="/assets/ourora_logo.png"
            alt="Ourora Logo"
            style={{ height: '40px', marginBottom: '16px' }}
          />
          <Text style={{ color: '#BFBFBF', display: 'block' }}>
            Sign in with your Google Workspace account
          </Text>
        </div>
        <Button
          type="primary"
          size="large"
          icon={<FontAwesomeIcon icon={faGoogle} />}
          onClick={handleGoogleLogin}
          block
          style={{
            background: '#DB50AC',
            borderColor: '#DB50AC',
          }}
        >
          Sign in with Google
        </Button>
      </Card>
    </div>
  );
};

export default Login;
